import React from 'react';
// import PropTypes from 'prop-types';
import { useUrlGenerator } from '@micromag/core/contexts';
import Viewer from '@micromag/viewer';
import { useParams } from 'wouter';

import { useStoryByPath } from '../../../contexts/StoryLinksContext';
import useStoryTrackingVariables from '../../../hooks/useStoryTrackingVariables';
import ViewerLayout from '../../layouts/Viewer';

import styles from '../../../../styles/pages/viewer/show.module.scss';

const propTypes = {};

const defaultProps = {};

const HomePage = () => {
    const { story_link: slug } = useParams();
    const url = useUrlGenerator();
    const storyPath = url('viewer.show', {
        story_link: slug,
    });
    const story = useStoryByPath(storyPath);
    const { organisation = null } = story;
    const { branding = {}, google_api_key: organisationGoogleApiKey = null } = organisation || {};
    const trackingVariables = useStoryTrackingVariables(story);

    return (
        <ViewerLayout>
            <div className={styles.container}>
                <Viewer
                    story={story}
                    theme={branding}
                    basePath={storyPath}
                    trackingVariables={trackingVariables}
                    googleApiKey={organisationGoogleApiKey}
                    fullscreen
                    withMetadata
                    // menuDotsButtons={<ConsentLink />}
                />
            </div>
        </ViewerLayout>
    );
};

HomePage.propTypes = propTypes;
HomePage.defaultProps = defaultProps;

export default HomePage;
